import { createContext } from "react";

/**
 * Session type matching Auth.js session structure
 */
export interface Session {
  user?: {
    name?: string | null;
    email?: string | null;
    image?: string | null;
  };
  expires?: string;
  error?: string;
}

export interface SessionContextValue {
  data: Session | null;
  status: "loading" | "authenticated" | "unauthenticated";
  isAuthEnabled: boolean;
  update: () => Promise<Session | null>;
}

export const SessionContext = createContext<SessionContextValue | undefined>(
  undefined,
);
